import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { organizationApi } from "@/api/organizationApi";

interface Organization {
  id: string;
  name: string;
  displayName?: string;
  description?: string;
  ownerUserId: string;
}

interface OrgState {
  list: Organization[];
  activeOrgId: string | null;
  loading: boolean;
}

const initialState: OrgState = {
  list: [],
  activeOrgId: localStorage.getItem("activeOrgId"),
  loading: false,
};

export const fetchOrganizations = createAsyncThunk("org/fetchAll", async () =>
  organizationApi.list(),
);

export const createOrganization = createAsyncThunk(
  "org/create",
  async (data: { name: string; displayName?: string; description?: string }) =>
    organizationApi.create(data),
);

const orgSlice = createSlice({
  name: "org",
  initialState,
  reducers: {
    setActiveOrg(state, action: PayloadAction<string>) {
      state.activeOrgId = action.payload;
      localStorage.setItem("activeOrgId", action.payload);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchOrganizations.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchOrganizations.fulfilled, (state, action) => {
        state.list = action.payload;
        state.loading = false;
        if (!state.activeOrgId && action.payload.length > 0) {
          state.activeOrgId = action.payload[0].id;
          localStorage.setItem("activeOrgId", action.payload[0].id);
        }
      })
      .addCase(fetchOrganizations.rejected, (state) => {
        state.loading = false;
      })
      .addCase(createOrganization.fulfilled, (state, action) => {
        state.list.push(action.payload);
        state.activeOrgId = action.payload.id;
        localStorage.setItem("activeOrgId", action.payload.id);
      });
  },
});

export const { setActiveOrg } = orgSlice.actions;
export default orgSlice.reducer;
